import React, { useState, useEffect } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ListTodo, CalendarDays } from "lucide-react";
import Tasks from "@/pages/Tasks";
import CalendarPage from "@/pages/CalendarPage";

/**
 * Página unificada Mis Tareas + Calendario con 2 tabs.
 * Default tab según ruta:
 *   /tareas → tab "tareas"
 *   /calendario → tab "calendario"
 * También respeta ?tab=tareas|calendario
 */
export default function TareasYCalendario() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const defaultTab = (() => {
    const q = searchParams.get("tab");
    if (q === "calendario" || q === "tareas") return q;
    return location.pathname.startsWith("/calendario") ? "calendario" : "tareas";
  })();
  const [tab, setTab] = useState(defaultTab);

  useEffect(() => {
    // Mantener URL sincronizada con la pestaña activa
    const targetPath = tab === "calendario" ? "/calendario" : "/tareas";
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
    if (searchParams.get("tab")) {
      const next = new URLSearchParams(searchParams);
      next.delete("tab");
      setSearchParams(next, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="bg-white border border-[#d1dbd6] inline-flex" data-testid="tareas-cal-tabs">
          <TabsTrigger value="tareas" className="data-[state=active]:bg-[#205c45] data-[state=active]:text-white gap-1.5" data-testid="tab-tareas">
            <ListTodo size={14} />
            Mis tareas
          </TabsTrigger>
          <TabsTrigger value="calendario" className="data-[state=active]:bg-[#205c45] data-[state=active]:text-white gap-1.5" data-testid="tab-calendario">
            <CalendarDays size={14} />
            Calendario
          </TabsTrigger>
        </TabsList>
        <TabsContent value="tareas" className="mt-4">
          <Tasks />
        </TabsContent>
        <TabsContent value="calendario" className="mt-4">
          <CalendarPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
